import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { getSolutionsFeatures } from '../../utils/get-solutions-features.js';
import SolutionsFeatures from '../SolutionsFeatures/SolutionsFeatures.js';
import SolutionsProductDetails from '../SolutionsProductDetails/SolutionsProductDetails.js';

const Description = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    if (!CommerceToolsApi.isSolutions(activeVariant)) {
        return null;
    }
    const labels = React.useMemo(()=>({
            description: activeVariant.description,
            header: activeVariant.header || getLabel('products.solutions.header.header'),
            title: getLabel('products.solutions.header.details') || 'Product Details',
            targetUsers: activeVariant.targetUsers,
            convenience: activeVariant.convenience,
            keyInstructions: activeVariant.keyInstructions,
            disclaimer: getLabel('products.solutions.features.disclaimer')
        })
    , [
        getLabel,
        activeVariant
    ]);
    const { solutionsFeatures  } = React.useMemo(()=>getSolutionsFeatures(activeVariant, getLabel)
    , [
        getLabel,
        activeVariant
    ]);
    return /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        title: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React.createElement(SolutionsFeatures, swcHelpers.extends({}, solutionsFeatures)), /*#__PURE__*/ React.createElement(SolutionsProductDetails, {
        targetUsers: labels.targetUsers,
        convenience: labels.convenience,
        keyInstructions: labels.keyInstructions,
        headerTitle: labels.title
    }), labels.disclaimer);
};

export { Description };
//# sourceMappingURL=Description.js.map
